const testimonials = [
  {
    name: "Robert H.",
    location: "PGA Village, Port St. Lucie, FL",
    rating: 5,
    text: "Our PGA Village golf group had a trip to St. Andrews planned for six months. Three weeks before departure, one of our regulars discovered his passport had expired. The group trip was non-refundable — losing his spot would have cost him $4,200 and disrupted the foursome pairings for the entire group. Fast Passport Center processed his renewal in five business days. He made the flight to Edinburgh, played all four rounds, and the trip went off without a hitch. Their team understood exactly what a golf trip deadline means.",
    service: "Passport Renewal",
  },
  {
    name: "Diane M.",
    location: "Tradition, Port St. Lucie, FL",
    rating: 5,
    text: "I am a retired nurse living in Tradition. My husband and I booked a Caribbean cruise from Port Canaveral for our 40th anniversary. Ten days before sailing, I checked our passports and realized mine had expired two months earlier. I panicked — 40 years of marriage and this was the trip we'd been planning for a year. Fast Passport Center walked me through the renewal process, I shipped everything overnight from the UPS Store on US-1, and my passport arrived in four days. We made the cruise. I cried when I held the new passport in my hands.",
    service: "Expedited Passport Renewal",
  },
  {
    name: "James K.",
    location: "Port St. Lucie, FL",
    rating: 5,
    text: "My daughter is a student at Indian River State College and was accepted into a summer study abroad program in Barcelona. The program required her passport number at application time — three months before departure. We submitted her application, but her passport had expired and we didn't realize it until the program coordinator called to say her application was incomplete. We had two weeks to get her passport renewed or she would lose her spot. Fast Passport Center handled the expedited renewal in six business days. She made the program, spent the summer in Barcelona, and came back fluent in Spanish.",
    service: "Expedited Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function PortStLucieTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Port St. Lucie Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Port St. Lucie golfers, retirees, families, and students who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}